import React from 'react';
import { Link, Preloader } from 'MWC';
import '../less/detailedNews.less';
import NotFound from '../views/not-found';
import Share from '../../Share';
import { LANG } from '../../../services/l10n';
import moment from 'moment/moment';

export default function template() {
    const { article, linkedNews, isShowPreloader } = this.state,
        isUa = this.props.lang === LANG.UA,
        isMobile = this.isViewportMobile(),
        title = isUa ? 'title_ua' : 'title_ru',
        content = isUa ? 'desc_ua' : 'desc_ru',
        preview = isUa ? 'preview_ua' : 'preview_ru',
        tagName = isUa ? 'name_ua' : 'name_ru',
        video = isUa ? 'video_url_ua' : 'video_url_ru',
        tags = article && article.news_by_tags.map(tag => [tag.tags[tagName]]),
        shareOptions = {
            url: window.location.href,
            text: article && article[title],
            tags,
        },
        news = linkedNews.map(article => {
            return (
                <div key={article.id} className="linked-news-item">
                    <img className="linked-news-img" src={article[preview]} alt="news" />
                    <div className="linked-news-content">
                        <div className="title">{article[title]}</div>
                        <Link href={`/news/${article.id}`} className="sorting-btn more-info">
                          {this.l10n('NEWS_READ')}
                        </Link>
                    </div>
                </div>
            );
        }),
        pageContent = isShowPreloader ? (<div className="preload-wrapper">
            <Preloader />
        </div>) : (article ? (
            <div className="content">
              <div className="flex-wrapper" style={{ marginBottom: '32px' }}>
                <div className="detailed-news-date">
                  {moment(article.date).locale('uk').format("DD MMMM yyyy")} {this.l10n('YYYY')}
                </div>
                <Share options={shareOptions} {...this.props} />
              </div>
              <h1
                className="detailed-news-title"
                dangerouslySetInnerHTML={{ __html: article[title] }}
              />
              <div className="detailed-news-content">
                <div
                  className="detailed-news-article"
                  dangerouslySetInnerHTML={{ __html: article[content] }}
                ></div>
                {article[video] &&
                  <div className="detailed-news-video">
                    <div className="news-video-wrapper">
                      <iframe
                        src={article[video]}
                        width="560" height="315"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        title='video'
                      />
                    </div>
                  </div>
                }
              </div>
              <div className="linked-news">{news}</div>
            </div>
          ) : (
            <NotFound />
          )
        );

  return <div className="detailed-news-module">{pageContent}</div>;
}
